import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

export const notificationService = {
  list: (p: { page?: number; limit?: number; user_id?: string; search?: string } = {}) => {
    const userType = localStorage.getItem('user_type') ?? 'ADMIN'
    let url = endpoints.notification.getList
    if (userType === 'ASSISTANT')    url = endpoints.notification.getListAssistant
    else if (userType === 'COLLECTOR')   url = endpoints.notification.getListCollector
    else if (userType === 'SCHOOL_ADMIN') url = endpoints.notification.getListSchoolAdmin

    const params = new URLSearchParams({ page: String(p.page ?? 1), limit: String(p.limit ?? 15), locale: 'en' })
    if (p.user_id) params.append('user_id', p.user_id)
    if (p.search) params.append('search', p.search)
    if (userType === 'SCHOOL_ADMIN') params.append('type', 'self')
    return restClient.get(`${url}?${params}`).then(r => r.data)
  },

  // Matches the old SendNotificationForm payload shape:
  // user_ids, user_type, title, locale, description, detail_message, send_all
  send: (data: {
    title: string
    description?: string
    body?: string
    detail_message?: string
    user_type?: string
    user_ids?: number[]
    send_all?: 0 | 1
    locale?: string
    target_type?: string
    schedule_at?: string
  }) => {
    const payload = {
      title:          data.title,
      description:    data.description ?? data.body ?? '',
      detail_message: data.detail_message ?? data.body ?? data.description ?? '',
      user_type:      data.user_type ?? data.target_type ?? 'STUDENT',
      user_ids:       data.user_ids ?? [],
      send_all:       data.send_all ?? 0,
      locale:         data.locale ?? 'En',
    }
    return restClient.post(endpoints.notification.send, payload).then(r => r.data)
  },

  // Register the device's FCM (web push) token with the backend so the current
  // user can receive notifications on this browser.
  updateFcmToken: (fcmToken: string) =>
    restClient.post(endpoints.notification.updateFcmToken, { fcm_token: fcmToken }).then(r => r.data),
}
